const areas = [
  {
    city: "Riverside",
    services: ["Towing", "Recovery", "Municipal Towing", "Impound"],
    primary: true,
  },
  {
    city: "Moreno Valley",
    services: ["Towing", "Transport", "Impound", "Law Enforcement"],
    primary: true,
  },
  {
    city: "Colton",
    services: ["Towing", "Recovery", "Roadside Assistance"],
    primary: false,
  },
  {
    city: "San Bernardino",
    services: ["Towing", "Heavy Transport", "Recovery"],
    primary: false,
  },
  {
    city: "Inland Empire",
    services: ["Full-Service Coverage", "Fleet Transport"],
    primary: false,
  },
  {
    city: "Southern California",
    services: ["Specialty Transport", "Law Enforcement Services"],
    primary: false,
  },
];

export default function ServiceAreas() {
  return (
    <section id="areas" className="bg-[#f8f8f6] py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">Where We Operate</span>
            <div className="w-8 h-px bg-[#D4AF37]"></div>
          </div>
          <h2
            className="text-[#0a0a0c] font-black text-4xl md:text-5xl mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Serving the Inland Empire
          </h2>
          <p className="text-[#555] text-lg max-w-2xl mx-auto">
            With facilities in Riverside and Moreno Valley, Exclusive Towing provides rapid-response coverage across the Inland Empire and broader Southern California region.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Map embed */}
          <div className="w-full lg:w-2/5 rounded-lg overflow-hidden border border-[#e0e0e0]" style={{ height: "420px" }}>
            <iframe
              title="Exclusive Recovery Inc Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3308.5!2d-117.3961!3d33.9806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcb0e0e0e0e0e1%3A0x0!2s3777+Placentia+Ln%2C+Riverside%2C+CA+92501!5e0!3m2!1sen!2sus!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* City grid */}
          <div className="w-full lg:w-3/5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {areas.map((area, i) => (
                <div
                  key={i}
                  className={`rounded-lg p-5 border ${
                    area.primary
                      ? "bg-[#0a0a0c] border-[#D4AF37]/40"
                      : "bg-white border-[#e0e0e0]"
                  }`}
                >
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`ri-map-pin-2-fill ${area.primary ? "text-[#D4AF37]" : "text-[#888]"} text-base`}></i>
                    </div>
                    <h3
                      className={`font-bold text-base ${area.primary ? "text-white" : "text-[#0a0a0c]"}`}
                      style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                      {area.city}
                    </h3>
                    {area.primary && (
                      <span className="ml-auto text-[10px] bg-[#D4AF37]/20 text-[#D4AF37] px-2 py-0.5 rounded-full tracking-wider uppercase">
                        HQ
                      </span>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {area.services.map((s, j) => (
                      <span
                        key={j}
                        className={`text-xs px-2 py-1 rounded-sm ${
                          area.primary
                            ? "bg-[#1a1a1c] text-[#b8b8b8]"
                            : "bg-[#f0f0ee] text-[#555]"
                        }`}
                      >
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Local SEO paragraph */}
            <p className="text-[#666] text-sm leading-relaxed mt-6">
              Exclusive Recovery Inc provides towing in Riverside, recovery services in Colton, transport services in Moreno Valley, and heavy-duty towing throughout San Bernardino County. As a municipal contract provider for the City of Riverside and City of Moreno Valley, the company maintains a trusted presence across the Inland Empire and Southern California.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
